// TODO: fill in this entire file
import { BoxShadow } from 'app/shared/theme/common/typings';

export const boxShadow: BoxShadow = {
  doubleShadow: 'none',
  singleShadow: 'none',
};
